/* eslint-disable */

import { makeStyles, Switch } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Delete, Visibility } from "@material-ui/icons";
import Edit from "@material-ui/icons/Edit";
import Search from "@material-ui/icons/Search";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import Select from "components/Select/Select";
import TablePaginate from "components/TablePaginate/TablePaginate";
import { chainOptions } from "const";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { collectionService } from "services/collectionService";
import { distributeService } from "services/distributeCoinService";
import { paymentCoinService } from "services/paymentCoinService";

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

export default function PaymentCoinIndex() {
  const classes = useStyles();
  const [size] = React.useState(10);
  const [open, setOpen] = useState(false);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [isRefresh, setIsRefresh] = useState(false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const [chainId, setChainId] = React.useState("-1");

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const getChainById = (id) => {
    const chain = chainOptions().find((c) => +c.value === +id);
    return chain ? chain.label : "Null";
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Chain",
        accessor: "chainId",
        Cell: function Tier(cell) {
          return getChainById(cell.value);
        },
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Swap Rate",
        accessor: "swapRate",
      },
      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return (
            <>
              <Action
                cell={cell}
                setItems={setItems}
                onCloseModal={handleClose}
              ></Action>
            </>
          );
        },
      },
    ],
    [handleClose, open]
  );

  function Thumbnail({ cell }) {
    return <img src={cell.value} alt="" style={{ height: "50px" }} />;
  }

  Thumbnail.propTypes = {
    cell: PropTypes.any,
  };

  async function fetchDistributeCoin() {
    const payload = {
      search,
      page,
      size,
      chainId: +chainId,
    };
    if (!payload.chainId || payload.chainId === -1) delete payload.chainId;
    try {
      const { data } = await paymentCoinService.getAll(payload);
      setItems(data.items);
      setCount(data.paginate.count);
      setPage(data.paginate.page);
      setIsRefresh(false);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    fetchDistributeCoin();
  }, [page, search, chainId]);

  return (
    <div>
      {confirm}
      <Link to="/admin/payment-coin/create">
        <Button color="info">Create new payment coin</Button>
      </Link>

      <div className={classes.filter}>
        <CustomInput
          labelText="Search"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Select
          label={"Chain"}
          value={chainId}
          onChange={setChainId}
          options={[{ value: "-1", label: "All" }, ...chainOptions()]}
        />
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}

IsHot.propTypes = {
  cell: PropTypes.any,
};

function IsHot({ cell }) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(cell.value);
  }, [cell]);

  function onChange(e) {
    setChecked(e.target.checked);
    toogleChecked(e.target.checked);
  }

  async function toogleChecked(isChecked) {
    const id = cell.row.original.id;
    try {
      const { data } = await collectionService.update(id, { isHot: isChecked });
      console.log(data);
      toast.success("Updated collections");
    } catch (e) {
      toast.error(e.response.data.message[0]);
    }
  }
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": "controlled" }}
      color="primary"
    />
  );
}

IsActivated.propTypes = {
  cell: PropTypes.any,
};

function IsActivated({ cell }) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(cell.value);
  }, [cell]);

  function onChange(e) {
    setChecked(e.target.checked);
    toogleChecked(e.target.checked);
  }

  async function toogleChecked(isChecked) {
    const id = cell.row.original.id;
    try {
      const { data } = await collectionService.update(id, {
        activated: isChecked,
      });
      console.log(data);
      toast.success("Updated collections");
    } catch (e) {
      toast.error(e.response.data.message[0]);
    }
  }
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": "controlled" }}
      color="primary"
    />
  );
}

function Action({ cell, onCloseModal, setItems }) {
  const [openDialogDel, setOpenDialogDel] = React.useState(false);

  const handleOpenDel = () => {
    setOpenDialogDel(true);
  };

  const handleCloseDel = () => {
    setOpenDialogDel(false);
  };

  const handleDelete = async (id) => {
    await paymentCoinService.remove(id);
    setItems((prev) => prev.filter((coin) => coin._id !== id));
    handleCloseDel();
  };

  return (
    <div className="actions-right">
      <Button
        justIcon
        round
        simple
        color="warning"
        className="edit"
        onClick={() => handleOpenDel()}
      >
        <Delete />
      </Button>

      <Dialog
        open={openDialogDel}
        onClose={handleCloseDel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm remove coin"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDel} color="transparent">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(cell.row.original._id);
            }}
            color="success"
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      <Link to={"/admin/payment-coin/edit/" + cell.row.original._id}>
        <Button justIcon round simple color="primary" className="edit">
          <Edit />
        </Button>
      </Link>
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  onCloseModal: PropTypes.any,
};

function View({ cell }) {
  return (
    <div className="actions-right">
      <Link to={"/admin/banner/" + cell.row.original.id}>
        <Button justIcon round simple color="success" className="edit">
          <Visibility />
        </Button>
      </Link>
    </div>
  );
}

View.propTypes = {
  cell: PropTypes.any,
};
